import { render, staticRenderFns } from "./ProductHuntModal.vue?vue&type=template&id=09fa6573&scoped=true"
import script from "./ProductHuntModal.vue?vue&type=script&lang=js"
export * from "./ProductHuntModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa6573",
  null
  
)

export default component.exports